import Axios from 'axios'
import Config from '@/config/index.js'
import i18n from '@/language'
import { getToken } from '@/utils/common.js'
import WBAppSdk from '@/utils/wb-app-sdk.js'
import { Notify } from 'vant'
import getErrorMessage from '@/utils/get-error-message.js'
import { buildReqDeviceInfo } from '@/utils/user-verify-helper.js'
import { ChangeHostConfig, ChangeHostUtil } from '@/utils/change-host'

const isUat = process.env.VUE_APP_ENV === 'uat'
const isProd = process.env.VUE_APP_ENV === 'prod'
const needChangeHost = !WBAppSdk.inApp && (isUat || isProd)

const service = Axios.create({
  baseURL: Config.apiUrl + '/' + Config.apiPrefix,
  headers: {
    Accept: '*/*'
  },
  timeout: Config.timeout
})

service.defaults.retry = Config.requestRetry
service.defaults.retryDelay = Config.requestRetryDelay
// let LoadingInstance = null;

// 设置axios切换baseURL函数
function setBaseURL(url) {
  service.defaults.baseURL = url
}

if (needChangeHost) {
  let changeHostConfig
  if (isUat) {
    changeHostConfig = {
      defaultHost: Config.apiUrl + '/' + Config.apiPrefix,
      backupReqUrl: 'https://winbull-quote.oss-cn-guangzhou.aliyuncs.com/bakcup.txt'
    }
  }
  // 工具初始化
  ChangeHostConfig.initConfig(changeHostConfig)
  ChangeHostUtil.init()
  // 执行一次设置baseURL
  setBaseURL(ChangeHostUtil.curHost)
}

// request拦截器【请求处理】
service.interceptors.request.use(
  async request => {
    if (!request.headers['Device-Info'] && !WBAppSdk.inApp) {
      request.headers['Device-Info'] = await buildReqDeviceInfo()
    }
    let token = getToken()
    if (!token && WBAppSdk.inApp) {
      const res = await WBAppSdk.getToken()
      if (res && res['token']) {
        token = res['token']
      }
    }
    if (token) request.headers['Authorization'] = `Bearer ${token}`
    request.params = { ...request.params, lang: i18n.locale || 'zh_CN' }
    return request
  },
  error => {
    return Promise.reject(error)
  }
)

// respone拦截器【相应处理】
service.interceptors.response.use(
  response => {
    const {
      data,
      status,
      config: { showError = true }
    } = response
    if (needChangeHost) {
      ChangeHostUtil.handleReqResOrErr({ res: response, setHostFunc: setBaseURL })
    }
    if (status === 200) {
      return data
    } else {
      showError && Notify({ type: 'warning', message: getErrorMessage(data) })
      return Promise.reject(data)
    }
  },
  error => {
    if (needChangeHost) {
      ChangeHostUtil.handleReqResOrErr({ err: error, setHostFunc: setBaseURL })
    }
    return Promise.reject(error)
  }
)

export default service
